module.exports = __webpack_public_path__ + "static/img/new-img04.5f27268a.webp";